import { useEffect, useState } from 'react'

export function useTimeLeft(callback?: () => void) {
  const [timeLeft, setTimeLeft] = useState<number | null>(null)

  useEffect(() => {
    if (timeLeft === 0) callback && callback()

    if (!timeLeft) return

    const intervalId = setInterval(() => {
      setTimeLeft(timeLeft - 1)
    }, 1000)

    return () => clearInterval(intervalId)
  }, [timeLeft])

  return { timeLeft, setTimeLeft }
}
